import React, { lazy, Suspense } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Loading from 'components/shared-components/Loading'
import { ADMIN_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions'))
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${ADMIN_PREFIX_PATH}/dashboard`}
          component={lazy(() => import('./dashboard'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/analytic`}
          component={lazy(() => import('./analytic'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/sanction`}
          component={lazy(() => import('./sanction'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/name-match`}
          component={lazy(() => import('./nameMatch'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/generic-ocr`}
          component={lazy(() => import('./generic-ocr'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/otp-providers`}
          component={lazy(() => import('./otp-providers/routes'))}
        />
        <Route
          path={`${ADMIN_PREFIX_PATH}/bundle-analytics/:clientId/:bundleId`}
          component={lazy(() => import('./analytic/BundleAnalytics'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/valify-sessions`}
          component={lazy(() => import('./sessions'))}
        />
                <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/sessions/:uniqueIdentifier`}
          component={lazy(() => import('./sessions/GovernanceSessions'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/transactions`}
          component={lazy(() => import('./transactions'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/export-data`}
          component={lazy(() => import('./exportData'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/export-transactions`}
          component={lazy(() => import('./exportTransactions'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/bundle-sessions/:bundleId`}
          component={lazy(() => import('./sessions/BundleSessions.js'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/sessions/:bundleId/:sessionId`}
          component={lazy(() => import('./sessions/SessionPage'))}
        />
        <Route
          exact
          path={[
            `${ADMIN_PREFIX_PATH}/sessions-details/:bundle_id/:user_reference_id/:action`, 
            `${ADMIN_PREFIX_PATH}/sessions-details/:bundle_id/:user_reference_id`
          ]}
          component={lazy(() => import('./unique-identifiers/session-details'))}
        />
        {/* <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/advanced-confidence`}
          component={lazy(() => import('./advanced-confidence/index'))}
        /> */}
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/clients`}
          component={lazy(() => import('./clients'))}
        />  
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/clients/:clientId`}
          component={lazy(() => import('./clients/clientPage'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/change-password`}
          component={lazy(() => import('./change-password/index'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/clients/:clientId/:bundleId`}
          component={lazy(() => import('./clients/bundlePage/index'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/passwordManagement`}
          component={lazy(() => import('./passwordManagement'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/identities/:bundleId/:userReferenceId`}
          component={lazy(() => import('./Identities/IdentityDetailPage'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/identities`}
          component={lazy(() => import('./Identities'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/sessions`}
          component={lazy(() => import('./unique-identifiers/UniqueIdentifiers'))}
        />
        
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/identities-details/:bundleId/:accountId/`}
          component={lazy(() => import('./identities-details/IdentitiesDetails'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/biometrics-guard`}
          component={lazy(() => import('./biometrics-guard'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/fra-requirements`}
          component={lazy(() => import('./fra-requirements'))}
        />
        <Route
          exact
          path={`${ADMIN_PREFIX_PATH}/audit-log`}
          component={lazy(() => import('./audit-log'))}
        />
        {permissions.includes('admin_analytics') ? (
          <Redirect from={`${ADMIN_PREFIX_PATH}`} to={`${ADMIN_PREFIX_PATH}/dashboard`} />
        ) : (
          <Redirect from={`${ADMIN_PREFIX_PATH}`} to={`${ADMIN_PREFIX_PATH}/sessions`} />
        )}
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews)
